var map = {
	"./inverter_blue.png": "d855",
	"./inverter_classic.png": "f845",
	"./inverter_disable.png": "185d",
	"./inverter_green.png": "ff1d",
	"./inverter_orange.png": "69ef",
	"./inverter_purple.png": "d320"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4698";